/**
 * Staleness derivations for the Feed health card.
 *
 * The card previously showed a green tick whenever an inventory source
 * existed, regardless of how long ago it last ingested — so a shop whose
 * stock file stopped uploading (St Peter's / DavRich) still looked healthy.
 *
 * 3 days matches the Unify dashboard's ConnectionStatusCard threshold
 * (NEA-5942), sitting below the 7/14/30-day escalation of the global
 * stale-ingest banners.
 */

export const STALE_INGEST_THRESHOLD_DAYS = 3;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function daysSince(iso) {
	if (!iso) return null;
	const t = Date.parse(iso);
	if (!Number.isFinite(t)) return null;
	return Math.floor((Date.now() - t) / MS_PER_DAY);
}

// Only an actual old timestamp counts as stale. A source with no ingest at
// all stays neutral — empty product sources are common placeholders created
// at signup, and flagging those would put a permanent false alarm on the card.
export function isStaleIngest(iso) {
	const days = daysSince(iso);
	return days != null && days >= STALE_INGEST_THRESHOLD_DAYS;
}

/**
 * Chain-level summary: of the locations that have ever sent stock data, how
 * many are still sending it? `connected` is the denominator (ever ingested),
 * `receiving` the healthy subset (ingested within the threshold).
 */
export function deriveLocationHealth(shops) {
	const connectedShops = (shops ?? []).filter((s) => s.stockInventorySource?.latestIngest?.timestamp);
	return {
		connected: connectedShops.length,
		receiving: connectedShops.filter((s) => !isStaleIngest(s.stockInventorySource.latestIngest.timestamp)).length
	};
}
